<template>
	<div>
		<div class="actDiv">
			<label>小区</label>
			<a-select  style="width:9rem; margin: 0 0.425rem;font-size: 0.6875rem;" v-model="theNeighbor.key" placeholder="请选择小区" label-in-value
									option-filter-prop="children"  :filter-option="filterOption" show-search allowClear @change="queryData">
				<a-select-option v-for="(item) in neighborList" :key="item.pId" :value="item.pId">{{item.neighborName}}</a-select-option>
			</a-select>
			<label>姓名</label>
			<a-input placeholder="请输入姓名" v-model="theCustomerName" style="width:9rem; margin: 0 0.425rem;font-size: 0.6875rem;" />
			<a-tooltip placement="topLeft" title="默认时间2000年到今天" arrow-point-at-center>
					<a-range-picker 
						:format="dateFormat" @change="onChange"  style="width:15rem; margin: 0 0.425rem;">
					</a-range-picker>
			</a-tooltip>
			
			<label>付费方式</label>
			<a-select style="width:9rem; margin: 0 0.425rem;font-size: 0.6875rem;" v-model="dataForm.pre" placeholder="请选择付费方式" >
				<a-select-option v-for="item in preType" :key="item.pre" :value="item.pre" :label="item.pre">{{item.preName}}</a-select-option>
			</a-select>
			<label>短信类型</label>
			<a-select style="width:10rem; margin: 0 0.425rem;" v-model="dataForm.messageMothods" placeholder="请选择短信类型" >
				<a-select-option v-for="item in messageType" :key="item.smsType" :value="item.smsType" :label="item.smsType">{{item.messageName}}</a-select-option>
			</a-select>
			<label>短信次数</label>
			<a-select style="width:9rem; margin: 0 0.425rem;font-size: 0.6875rem;" v-model="dataForm.sendTimes" placeholder="请选择发送次数" >
				<a-select-option v-for="item in messageTimes" :key="item.smsTime" :value="item.smsTime" :label="item.smsTime">{{item.timeName}}</a-select-option>
			</a-select>
			<a-button size="small"   icon="search" @click="doQuery" style="margin: 0 0.425rem;">查询</a-button>
			<a-button  size="small"    @click="doPrint" style="margin: 0 0.425rem;" :disabled="isdoPrint" icon="printer">打印</a-button>
		</div>
  	<!-- 短信发送记录表格 -->
		<a-table  size="small" :columns="columns" :data-source="smsLogStatisList" bordered :loading="loading"  rowKey="pId"
						:scroll="{y:600}" :pagination="false"  @change="handleTableChange" >
			<span slot="prepaySignSlot" slot-scope="text, record">
				{{record.paymentMethod ==1 ?'预付费':'后付费'}}
			</span>
		</a-table>
		<div class="footer">
			<a-row :gutter="5">
				<a-col :span="6">
					 <label>余额统计</label>
					<a-table size="small" :columns="balancecolumns" :data-source="balanceList" bordered 
						:rowKey="balanceList.neighborName" :pagination="false" :loading="loading1" style="margin-top:1rem;">
					</a-table>
				</a-col>
			</a-row>	
		</div>
	</div>
</template>

<script>
import moment from 'moment';
export default{
  created(){
    this.queryNeighbors();
		this.createTime();
  },
  data(){
		const balancecolumns = 
				[{
					title: '小区名',
					dataIndex: 'neighborName',
					width: 80,
					className:'v-cell',
					align:'center',
				},
				{
					title: '余额',
					dataIndex: 'balance',
					width: 80,
					className:'v-cell',
					align:'center',
				}
			];
		const columns = [
				{
					title: '# ',
					key:'index',
					dataIndex: 'index',
					width:30,
					customRender: (text,record,index) => 
					(this.page-1)*this.pageSize+index+1,
					className:'v-cell',
					align:'center',
				},
				{
					title: '水费号',
					dataIndex: 'customersId',
					width:60,
					className:'v-cell',
					align:'center',
				},
				{
					title: '用户号',
					dataIndex: 'customersNum',
					width:60,
					className:'v-cell',
					align:'center',
				},
				{
					title: '用户名',
					dataIndex: 'customersName',
					width:80,
					className:'v-cell',
					align:'center',
				},
				{
					title: '地址',
					dataIndex: 'address',
					width:140,
					ellipsis:true,
					className:'v-cell',
					align:'center',
				},
				{
					title: '表底数',
					dataIndex: 'readData',
					width:60,
					className:'v-cell',
					align:'center',
				},
				{
					title: '余额',
					dataIndex: 'balance',
					width:60,
					className:'v-cell',
					align:'center',
				},
				{
					title: '电话',
					dataIndex: 'phone',
					width:80,
					className:'v-cell',
					align:'center',
				},
				{
					title: '付费方式',
					dataIndex: 'paymentMethod',
					width:60,
					scopedSlots: { customRender: 'prepaySignSlot' },
					className:'v-cell',
					align:'center',
				},
				{
					title: '发送时间',
					dataIndex: 'time',
					width:100,
					className:'v-cell',
					align:'center',
				},
				{
					title: '发送次数',
					dataIndex: 'sendTimes',
					width:60,
					className:'v-cell',
					align:'center',
				},	
				{
					title: '表状态',
					dataIndex: 'meterStateName',
					width:60,
					className:'v-cell',
					align:'center',
				},	
				{
					title: '短信类型',
					dataIndex: 'messageTypeName',
					width:60,
					className:'v-cell',
					align:'center',
				},		
			];
    return{
			neighborId:0,
			balancecolumns,
			balanceList:[],
			isdoPrint:true,
			neighborName:"未选择",
			sumBalance:0,
			meterState:null,
			columns,
			pagination:null,
			page:null,
			pageSize:null,
			loading:false,
			loading1:false,
			smsLogStatisList:[],
      dateEnd:null,
			dateStart:"2000-01-01",
      dateFormat: 'YYYY-MM-DD',
      theCustomerName:null,
			// theNeighborNameList:[],
      theNeighbor:{
				key:undefined,
				label:null
				},
      neighborList:[{
				pid:null
			}],
      preType:[
				{
				pre:0,
				preName:'后付费'
				},
				{
				pre:1,
				preName:'预付费'
				},
				{
				pre:2,
				preName:'全部'
				},
			],
      messageType:[
				{
				smsType:0,
				messageName:'全部'
				},
				{
				smsType:1,
				messageName:'欠费催缴'
				},
				{
				smsType:2,
				messageName:'停水通知'
				},
        {
        smsType:3,
				messageName:'其他通知'
				},
			],
      messageTimes:[
				{
				smsTime:0,
				timeName:'全部'
				},
				{
				smsTime:1,
				timeName:'第一条'
				},
				{
				smsTime:2,
				timeName:'第二条'
				},
			],
      dataForm:{
				pre:2,
        messageMothods:0,
        sendTimes:0,
			},
    }
  },
  methods:{
		queryData:function(){
			if(this.theNeighbor.key==undefined){
				this.neighborId=0;
			}else{
				this.neighborId=this.theNeighbor.key.key;
				this.neighborName=this.theNeighbor.key.label;
			}
				
		},
		doPrint:function(){
			let url = this.Api.getLastUrl('/report/smsLogListReport');
			let userId = this.Config.getUserLocal().pId;
			console.log(url+'?userId='+userId+"&neighbor="+this.neighborName+"&start="+this.dateStart+"&end="+this.dateEnd, "_blank");
			window.open(url+'?userId='+userId+"&neighbor="+this.neighborName+"&start="+this.dateStart+"&end="+this.dateEnd+"&neighborId="+this.neighborId+"&customerName="+this.theCustomerName, "_blank");
		},
		changeDate:function (data) {
			var date = new Date(data)
			var Y = date.getFullYear() + '-'
			var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
			var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
			var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
			var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
			var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
			return Y + M + D + h + m + s;
		},
		handleTableChange:function(pagination,filters,sorter){
			this.pageSize = pagination.pageSize;
			this.page = pagination.current;
			this.pagination = JSON.parse(JSON.stringify(pagination));
		},
    doQuery:function(){
			this.isdoPrint=true;
			this.smsLogStatisList = [];
				if(this.theNeighbor.key !=null && this.theNeighbor.key!=undefined||this.theCustomerName!=null){
					this.loading = true;
					let url = this.Api.getLastUrl(this.Api.STATIS_LIST_MESSAGE_LOG_URL);
					let userId = this.Config.getUserLocal().pId;
					let param = {};
					if(this.theNeighbor.key==undefined){
						param = {userId,neighborId:0,pre:this.dataForm.pre,end:this.dateEnd,start:this.dateStart,customersName:this.theCustomerName,messageType:this.dataForm.messageMothods,sendTimes:this.dataForm.sendTimes};
					}else{
						// this.neighborId=this.theNeighbor.key.key;
						// this.neighborName=this.theNeighbor.key.label;
						param = {userId,neighborId:this.theNeighbor.key.key,pre:this.dataForm.pre,end:this.dateEnd,start:this.dateStart,customersName:this.theCustomerName,messageType:this.dataForm.messageMothods,sendTimes:this.dataForm.sendTimes};
					}
					this.Api.fetchPostWithForm(url,param).then((data)=>{
						this.loading = false;
						let code = data.data.code;
						let result = data.data.result;
						let msg = data.data.message;
						if(code == this.Api.HTTP_OK_CODE){
							if(this.theNeighbor.key==undefined){
								this.neighborName=result[0].neighborName;
							}
							result.forEach(element => {
								if(element.sumBalance!=null){
									this.sumBalance=element.sumBalance;
								}else{
									element.time=this.changeDate(element.time);
								}
							});
							this.smsLogStatisList = result;
							this.smsLogStatisList.pop();
							console.log(this.sumBalance);
							this.isdoPrint=false;
						}else{
							this.$message.error(msg);
						}
					}).catch((error)=>{
						console.log(error);
						this.loading = false;
					});

					//发送第二个请求，通过名字查不同的小区，并算出总余额
					this.loading1 = true;
					url = this.Api.getLastUrl(this.Api.STATIS_LIST_MESSAGE_LOG_BYNAME_URL);
					this.Api.fetchPostWithForm(url,param).then((data)=>{
						this.loading1 = false;
						let code = data.data.code;
						let result = data.data.result;
						let msg = data.data.message;
						if(code == this.Api.HTTP_OK_CODE){
							this.balanceList=result;
						}
						
					}).catch((error)=>{
						console.log(error);
						this.loading1 = false;
					});
				}else{
					this.$message.error('请选择小区');
				}
			},
    moment,
	unique (arr) {
  		return Array.from(new Set(arr))
		},
    onChange(date, dateString) {
			this.dateStart=dateString[0];
			this.dateEnd=dateString[1];
			console.log(this.dateStart+"---------"+this.dateEnd);
    },
		createTime:function(){
			this.dateStart="2000-01-01";
			this.dateEnd=new Date().toLocaleDateString();
		},
    queryNeighbors:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
    filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
		},
  }
}
</script>

<style>
.footer{
	height: 300px;
	width: 1300px;
	margin-top: 0px;
	margin-left: 3rem;
}
</style>
